
import React, { useEffect } from "react";

import { googleMapKey } from "../../variables/apikeys";
// style route map
import '../../assets/scss/route-map.scss';

import { colors, opacities, borderWeights, getIcon, MODE_GRAB, MODE_MARKER, MODE_POLYGON } from "../../variables/maps";
import { google } from "../../common/StaticMap";
import Common from '../../common/Common';


/* マップ単体を使用する場合のコンポーネントクラス */
export default class DetailMap extends React.Component {
    constructor (props) {
        super(props);

        this.state={
            isMount : false,
            viewRequestNumber : this.props.requestNumber? this.props.requestNumber : undefined,
            parkingData : this.props.parkingData? this.loadParkingData(this.props.parkingData): undefined,
            basemapData : this.props.basemapData? this.props.basemapData: undefined,
            flaggedParking:this.props.flaggedParkings?this.props.flaggedParkings:[],
            googleObjects: {
                map: undefined,
                window: undefined,
                render: undefined,
                lines : undefined
            },
            start : {
                lat : this.props.start? this.props.start.lat: 0,
                lng : this.props.start? this.props.start.lng: 0,
            },
        }

        this.map = null;

        this.onLoadDirections = this.onLoadDirections.bind(this);
        this.callbackGesture = this.callbackGesture.bind(this);
        this.drawingMap = this.drawingMap.bind(this);
        this.drawPolygons = this.drawPolygons.bind(this);
    }
    loadParkingData ( data ) {
        if ( data ) {
            let parkingDatas = {};

            data.map((item)=>{
                parkingDatas[item.request_parking_ulid] = {
                    data : item,
                    render: undefined,
                    distinates_marker: undefined,
                    markers: [],
                    flagged_markers: [],
                    lines: [...item.direction.points],
                    text: item.direction.markers.text,
                    color: item.direction.markers.color,
                    lat: item.direction.markers.lat,
                    lng: item.direction.markers.lng,
                    polygons: [],
                    map_options: {
                        center: {
                            lat: item.direction.markers.lat,
                            lng: item.direction.markers.lng,
                        },
                        zoom: 18,
                        gestureHandling:"greedy",
                        streetViewControl: false,
                        rotateControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false
                    },
                    draw_options: {
                        draggable: false,
                        preserveViewport: true,
                        markerOptions: true,
                        suppressMarkers: true,
                        polylineOptions: {
                            strokeColor: item.direction.color,
                            strokeOpacity: item.direction.opacity,
                            strokeWeight: item.direction.weight
                        },
                    }
                } 
            })
            return parkingDatas;
        }
    }
    componentDidMount () {
        Common.waitForTrue(() => typeof ZisAuth !== undefined, this.loadMap.bind(this))
    }

    callbackGesture () {
        if ( this.props.callbackGesture ) {
            this.props.callbackGesture(this.state.viewRequestNumber, {
                zoom : this.state.parkingData[this.state.viewRequestNumber].map_options.zoom,
                lat: this.state.parkingData[this.state.viewRequestNumber].map_options.center.lat,
                lng: this.state.parkingData[this.state.viewRequestNumber].map_options.center.lng
            })
        }
    }

    componentDidUpdate (prevProps) {
        let isUpdate = false;        
        let reloadMap = false;
        let stateData = this.state;

        if ( Object.keys(prevProps.parkingData).length != Object.keys(this.props.parkingData).length ||
           ( prevProps.parkingData == undefined && this.props.parkingData != undefined ) ) 
        {
            stateData = {
                ...stateData,
                parkingData : this.loadParkingData(this.props.parkingData),
            }
            isUpdate = true;
        }
        if (prevProps.requestNumber != this.props.requestNumber) {
//            console.log(prevProps.requestNumber, this.props.requestNumber);
            stateData = {
                ...stateData,
                viewRequestNumber : this.props.requestNumber,
            }
            isUpdate = true;
            reloadMap = true;
            let {polylines, markers, flagged_markers, polygons} = this.state.parkingData[this.state.viewRequestNumber];
            let destinateMaker = this.state.parkingData[this.state.viewRequestNumber].destinateMarker;
            // console.log(this.state.parkingData[this.state.viewRequestNumber])
            console.log(destinateMaker,polylines, markers, flagged_markers, polygons)
            destinateMaker != undefined && this.map.removeWidget(destinateMaker)
            polylines != undefined && polylines.map((pl)=>this.map.removeWidget(pl))
            markers.map((m)=>this.map.removeWidget(m))
            flagged_markers.map((fm)=>this.map.removeWidget(fm))
            polygons.map((p)=>this.map.removeWidget(p))

            console.log("componentDidUpdate",this.state.viewRequestNumber,this.state.parkingData[this.state.viewRequestNumber].lat,this.state.parkingData[this.state.viewRequestNumber].lng)

        }

        if (isUpdate) {
            this.setState(stateData,()=>{
                if (reloadMap) {
                    this.onLoadDirections();
                    this.callbackGesture();
                }
            });
        }
    }

    loadMap () {
        if ( this.state.parkingData == undefined || 
             this.state.viewRequestNumber == undefined || 
             this.state.parkingData[this.state.viewRequestNumber] == undefined) 
        {
            return ;
        }

        let parkingData = this.state.parkingData[this.state.viewRequestNumber];
        let map_settings = parkingData.map_options
        ZisAuth.addEventListener("ready", function(e) {
            var mapOptions = ZisAuth.getMapOption();
            mapOptions.center = new ZDC.LatLng(map_settings.center.lat, map_settings.center.lng);
            mapOptions.zoom = map_settings.zoom;
            mapOptions.zipsMapType = 'kP8KjZdn';
            mapOptions.mouseWheelReverseZoom = true;
            this.map = new ZDC.Map(
                document.getElementById('DetailMap'),
                mapOptions,
                function () {
                    // Success callback
                    this.map.addControl(new ZDC.ZoomButton('top-left'));

                    this.map.addEventListener('zoom_changed', (e) => {
                        let zoom = this.map.getZoom();
                        this.setState({
                            parkingData: {
                                ...this.state.parkingData,
                                [this.state.viewRequestNumber]: {
                                    ...this.state.parkingData[this.state.viewRequestNumber],
                                    map_options: {
                                        ...this.state.parkingData[this.state.viewRequestNumber].map_options,
                                        zoom: zoom
                                    }
                                }
                            }
                        }, () => this.callbackGesture()); 

                    });
                    this.map.addEventListener('mouseup', (e) => {
                        let parkingData = this.state.parkingData
                        parkingData[this.state.viewRequestNumber].map_options.center.lat = this.map.getCenter().lat
                        parkingData[this.state.viewRequestNumber].map_options.center.lng = this.map.getCenter().lng
                        this.setState({ parkingData: parkingData }, () => this.callbackGesture());
                    });

                    this.onLoadDirections();
                }.bind(this),
                function () {
                    // Failure callback
                }.bind(this)
            );
        }.bind(this));

    }
    addSvgPinMarker (latLng, labelText, color="#8B0000") {
        let path = "M82 464 c-51 -26 -77 -70 -77 -130 0 -43 7 -62 52 -136 29 -47 60 -105 68 -129 9 -24 18 -51 21 -59 3 -9 13 8 23 41 10 32 42 95 70 142 61 99 72 147 46 201 -35 73 -131 106 -203 70z"
        let size = { width: 30, height: 48}
        const svg = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="${size.width}pt" height="${size.height}pt" viewBox="0 0 ${size.width} ${size.height}" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,${size.height}.000000) scale(0.100000,-0.100000)" fill="${color}" stroke="none">
        <path d="${path}" />
        </g><text style="fill: #FFFFFF" x="${size.width/2}" y="${size.height/2-3}" text-anchor="middle">${labelText}</text></svg>`
        const iconSvgUrl = `data:image/svg+xml,${encodeURIComponent(svg)}`;

        let marker = new ZDC.Marker(
            new ZDC.LatLng(latLng.lat, latLng.lng),
            {
                custom: {
                    base: {
                        imgPos: new ZDC.Point(((size.width / 2) * -1) - 5, (size.height * -1) - 15), // 位置微調整
                        imgSrc: iconSvgUrl
                    }
                }
            }
        );
        this.map.addWidget(marker);
        return marker
    }
    addDistinateMarker () {
        let parkingData = this.state.parkingData[this.state.viewRequestNumber];
        let latLng = {lat:parkingData.lat, lng:parkingData.lng};
        // 地図中心に設定
        this.map.setCenter(new ZDC.LatLng(parkingData.lat, parkingData.lng))
        console.log(parkingData.lat,parkingData.lng)
        return this.addSvgPinMarker(latLng, parkingData.text, parkingData.color)
    }

    drawingMap () {
        let index;
        let n = 0;
        let numbers = Object.keys(this.state.parkingData)
        numbers.forEach((number, n)=>{
            if ( this.state.viewRequestNumber == number) {
                index = Math.floor(n / 3)
            }
            n ++;
        })
        let {memos, polygons} = this.state.basemapData[index].objects;

        let array_polygons = polygons.map((polygon)=>{
            return this.drawPolygons(polygon);
        })
        let array_markers = memos.map((m)=>{
            let {lat, lng, text, color} = m.memo.marker
            return this.addSvgPinMarker ({lat:lat, lng:lng}, text, color);
        })
        return {polygons: array_polygons, markers: array_markers}
    }

    drawPolygons (objects) {
        let polygonOptions = objects.polygon;
        let latlngs = []
        polygonOptions.points.forEach((latLng) => {
            latlngs.push(new ZDC.LatLng(latLng.lat, latLng.lng))
        })
        var plg = new ZDC.Polygon(latlngs, {
            fill: polygonOptions.fillcolor,
            stroke: polygonOptions.fillcolor,
            strokeWidth: polygonOptions.weight,
            opacity: polygonOptions.opacity,
            propagation: true
        });
        this.map.addWidget(plg);
        return plg
    }

    onLoadDirections (init=true) {
        let parkingDatas = this.state.parkingData
        let parkingData = parkingDatas[this.state.viewRequestNumber];

        let icon = getIcon("site");
        let marker = new ZDC.Marker(
            new ZDC.LatLng(this.state.start.lat, this.state.start.lng),
            {
                custom: {
                    base: {
                        imgSrc: icon.iconLinkUrl
                    }
                }
            }
        );
        this.map.addWidget(marker);
        let destinateMarker = this.addDistinateMarker();

        let points = parkingData.lines
        var latlngs = [];
        points.forEach((point) => {
            latlngs.push(new ZDC.LatLng(point.Lat, point.Lng))
        })
        let options = parkingData.draw_options
        let polylines = []
        if(latlngs.length >= 3) {
            var pli = new ZDC.Polyline(
                latlngs,
                {
                    color: options.polylineOptions.strokeColor,
                    opacity: options.polylineOptions.strokeOpacity,
                    width: options.polylineOptions.strokeWeight
                }
            );
            this.map.addWidget(pli);
            polylines.push(pli)
        }

        // console.log(this.state.parkingData[Object.keys(this.state.parkingData)[0]].data.site_distance_minute, latlngs)

        if(this.state.parkingData[Object.keys(this.state.parkingData)[0]].data.site_distance_minute >= 5) {
            // 現場、駐車場間が５分以上ならズームレベルを画面に収まるように変更
            var centerZoom = this.map.getAdjustZoom(latlngs, {fix: true})
            parkingData.map_options.zoom = centerZoom.zoom
            // this.map.setZoom(centerZoom.zoom)
        }
        // console.log(parkingData.map_options.zoom)
        this.map.setZoom(parkingData.map_options.zoom);

        parkingData.destinateMarker = destinateMarker;
        parkingData.polylines = polylines;
        // 図形とメモマーカの描画
        let drawerObjects = this.drawingMap()
        parkingData.polygons = [...drawerObjects.polygons];
        parkingData.markers = [...drawerObjects.markers];
        parkingDatas[this.state.viewRequestNumber] = parkingData;

        this.setState({parkingData: parkingDatas},()=>{window.scrollTo(0,0);})
    }

    handleLocationError(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
            browserHasGeolocation
                ? "Error: The Geolocation service failed."
                : "Error: Your browser doesn't support geolocation."
        );
//        infoWindow.open();
    }

    render () {
        return (<>
            <div id="DetailMap" name="DetailMap" className="map-polygon" style={{height:"1200px", width:"1280px"}} />
        </>);
    }
}